import * as angular from "angular";

export class FormUtils {
    focusingFirstInvalid(): void {
        let parent = document
            .querySelector("form.ng-invalid")
            .querySelector(".ng-invalid");
        parent.classList.add("invalid-form");
        (parent as any).focus();
    }

    dateIsReal(day: string, month: string, year: string): boolean {
        const dateString = year + "-" + month + "-" + day;
        const regEx = /^[0-9]{4}\-(0[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])/;
        if (!dateString.match(regEx)) {
            return false;
        }

        const date = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day)
        );
        return (
            angular.isDate(date) &&
            date.getDate() === parseInt(day) &&
            date.getMonth() + 1 === parseInt(month) &&
            date.getFullYear() === parseInt(year)
        );
    }

    birthYearValid(year: string | number): boolean {
        if (typeof year === "string") year = parseInt(year);

        return (
            angular.isDefined(year) &&
            year &&
            year.toString().length == 4 &&
            year <= new Date().getFullYear() &&
            year >= 1870
        );
    }
}

angular.module("vcHelper").service("FormUtils", FormUtils);
